import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Maryland = () => {
  return (
    <StatePropertyTaxPage
      stateName="Maryland"
      processDescription="Appeals must be filed with SDAT within 45 days of the notice mailing. Hearings can be written, by phone, video, or in-person. Final appeal goes to the Maryland Tax Court."
      noticeOfValueMailed="January"
      noticeOfValueMailedDateExplanation="Assessment notices are mailed in late December or early January."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Maryland assesses property as of January 1 each year. Properties are reassessed every three years to ensure current market values are reflected in assessments."
      deadlineExplanation="Appeals must be received within 45 days of assessment mailing. This deadline is strictly enforced, so property owners should file promptly upon receiving their assessment notice."
    />
  );
};

export default Maryland;